import {Injectable} from '@angular/core';
import {UserInterface} from '../../../shared/interfaces/user.interface';
import {TokenStorageService} from './token-storage.service';
import {SuperService} from '../../../clients/shared/service/super.service';
import {AlertService} from '../../../shared/services/alert.service';
import {isTestEnvironment} from '../../../../main';

@Injectable({
  providedIn: 'root'
})

export class SharedDataStorageService {
  public userProfile: UserInterface;
  constructor(
    private tokenStorageService: TokenStorageService,
    private superService: SuperService,
    private alertService: AlertService
  ) {}

  public loadCustomerPaymentStatus(){
    if (isTestEnvironment) {
      this.alertService.handleApiResponse(3);
      return;
    }
    this.userProfile = this.tokenStorageService.getUser();
    if (Object.keys(this.userProfile).length > 0) {
      this.superService.getCustomerPackagePaymentStatus(this.userProfile.id)
        .subscribe(data => {
          let showAlert = 0; // data.package_payment_status === 'not_paid';
          if (data.package_payment_status === 'not_paid') {
            showAlert = 1;
            if (data.unpaid_days > 30) {
              showAlert = 2;
            }
          }

          this.tokenStorageService.savePackagePaymentStatus(data.package_payment_status, data.unpaid_days);
          this.alertService.handleApiResponse(showAlert);
        }, error => {
          this.alertService.handleApiResponse(0);
        });
    }
  }
}
